import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Level2Icon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M6.3 21.29c0 .2-.06.38-.18.53a.87.87 0 0 1-.55.18H2.73a.7.7 0 0 1-.73-.71v-7.15c0-.2.08-.37.23-.49a.6.6 0 0 1 .5-.22h2.84c.22 0 .4.07.55.22.12.12.19.28.19.5v7.14Zm7.35 0c0 .2-.06.38-.18.53a.87.87 0 0 1-.55.18h-2.84a.7.7 0 0 1-.73-.71V8.57c0-.2.07-.37.23-.49a.6.6 0 0 1 .5-.22h2.84c.21 0 .4.07.55.22.12.12.18.28.18.5v12.7Z" /><path opacity=".3" d="M21 21.29c0 .2-.06.38-.18.53a.87.87 0 0 1-.55.18h-2.84a.7.7 0 0 1-.74-.71V2.7c0-.2.08-.37.23-.49.13-.15.3-.22.5-.22h2.85c.21 0 .4.07.55.22.12.12.18.29.18.5v18.57Z" />
    </SvgIcon>
);
